"use client";

import { useTenant } from "@tillix/tenants/react";
import { BaseFieldRoot, type BaseFieldRootProps } from "./field-root";
import ConEdisonFieldRoot from "./field-root.con-edison";
import type { OptionalTenantProp } from "../../../../types";

export function FieldRoot(props: BaseFieldRootProps & OptionalTenantProp) {
  const contextTenant = useTenant();

  const tenantRefId = props.tenant?.id ?? contextTenant?.id;

  switch (tenantRefId) {
    case "con-edison":
      return <ConEdisonFieldRoot {...props} />;

    default:
      return <BaseFieldRoot {...props} />;
  }
}
